import { NavLink } from "react-router-dom";
const NotFoundPage = () => {
  return (
    <>
      <div className="h-dvh grid place-items-center">
        <div>
          <h2 className="text-center font-bold text-2xl md:text-3xl lg:text-5xl">
            404
          </h2>
          <h1 className="text-xl md:text-2xl lg:text-4xl mt-8 mb-4">
            لم يتم العثور على الصفحة
          </h1>
          <p>
            <NavLink to="/" className={"underline hover:underline-offset-1"}>
              العودة إلى الصفحة الرئيسية
            </NavLink>
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
